import { render, staticRenderFns } from "./FeeVoucherDetailComponent.vue?vue&type=template&id=d666089a&"
import script from "./FeeVoucherDetailComponent.vue?vue&type=script&lang=js&"
export * from "./FeeVoucherDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports